import BaseApiClient from '@api-client/BaseApiClient';
import { FlightplanKybInterface } from '@interfaces/FlightplanKyb.interface';

export class ApiFlightplanKyb extends BaseApiClient {
  get(): Promise<FlightplanKybInterface> {
    return new Promise((resolve) => {
      this.client
        .get('/kyb-new')
        .then((res) => resolve(res.data))
        .catch(console.error);
    });
  }

  post(body: { company_id: number; stage: string }): Promise<any> {
    return new Promise((resolve) => {
      this.client
        .post('/kyb-new', body)
        .then((res) => resolve(res.data))
        .catch(console.error);
    });
  }

  put(id: number, body: { stage: string }): Promise<any> {
    return new Promise((resolve) => {
      this.client
        .put(`/kyb-new/${id}`, body)
        .then((res) => resolve(res.data))
        .catch(console.error);
    });
  }

  postStage(id: number, stage: string, body: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.client
        .post(`/kyb-new/${id}/${stage}`, body)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }

  putStage(
    id: number,
    stage: string,
    dueDiligenceId: number,
    body: any
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this.client
        .put(`/kyb-new/${id}/${stage}/${dueDiligenceId}`, body)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }

  putDirectorsStage(id: number, directorId: number, body: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.client
        .put(`/kyb-new/${id}/director/${directorId}`, body)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }

  sendVerificationEmails(id: number): Promise<any> {
    return new Promise((resolve) => {
      this.client
        .post(`/kyb-new/${id}/send-verification-emails`)
        .then((res) => resolve(res.data))
        .catch(console.error);
    });
  }

  resendVerificationEmail(id: number, directorId: number): Promise<any> {
    return new Promise((resolve) => {
      this.client
        .post(`/kyb-new/${id}/director/${directorId}/resend-verification-email`)
        .then((res) => resolve(res.data))
        .catch(console.error);
    });
  }

  createComplianceTasks(id: number): Promise<any> {
    return new Promise((resolve) => {
      this.client
        .post(`/kyb-new/${id}/create-compliance-tasks`)
        .then((res) => resolve(res.data))
        .catch(console.error);
    });
  }
}

export { flightplanKybQueryKeys } from './query-keys';
export { useFlightplanKybQuery } from './use-flightplan-kyb-queries';
export {
  useFlightplanKybCreateComplianceTasksMutation,
  useFlightplanKybPostMutation,
  useFlightplanKybPostStageMutation,
  useFlightplanKybPutDirectorsStageMutation,
  useFlightplanKybPutMutation,
  useFlightplanKybPutStageMutation,
  useFlightplanKybResendVerificationEmailMutation,
  useFlightplanKybSendVerificationEmailsMutation
} from './use-flightplan-kyb-mutations';
export type {
  FlightplanKybPostStageVariables,
  FlightplanKybPostVariables,
  FlightplanKybPutDirectorsStageVariables,
  FlightplanKybPutStageVariables,
  FlightplanKybPutVariables,
  FlightplanKybResendVerificationEmailVariables
} from './use-flightplan-kyb-mutations';
